import React from 'react';
import './splash.css'
import pic4 from '../assets/pic4.png'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Splash  = () => {
     const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/home');
        }, 2000); 

        return () => clearTimeout(timer);
    }, [navigate]);

    return ( 
       <main className='splashpage-container'>
            <section className='container-splash-page'>
                <div className='game-title-logo'>
                    <h1 className='game-name'>Desert Treasure Run</h1>
                      <h1 className='text-effect'>Desert Treasure Run</h1>
                </div>
                <div className='progress-bar-splash'>
                    <div className='progess-line-splash'></div>
                </div>
            </section>

            <img src={pic4} alt='charcter' className='character-spalsh-page'></img>
       </main>
     );
}
 
export default Splash ;